import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class EmploymentFormService {

	constructor(public http: HttpClient) { }

	public getUniversityListByCountryForAboveHSC(countryId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getUniversityListByCountryId/' + countryId)
	}

	public getUniversityListByCountryForBelowHSC(countryId, qualificationId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getUniversityListByBoardType/' + qualificationId + '/' + countryId)
	}

	public getDicsiplineListByQualId(qualId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getDicsiplineListByQualId/' + qualId)
	}

	public getQualificationLevel(): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getQualificationDtoList')
	}

	public getUniversityDegreeProgramListForHSCorSSC(universityId, qualificationId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getUniversityDegreeProgramList/' + qualificationId + '/' + universityId)
	}

	public getUniversityDegreeProgramForNonHSCorSSC(universityId, qualificationId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getDegCampDeptTypeSessDetails/' + qualificationId + '/' + universityId + '/0/0/0/0/0/' + 'degreeProgram')
	}

	public getUniversityChangeNames(universityId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getUniversityChangeNames/' + universityId)
	}

	public getUniversityCampus(qualificationId, universityId, universityDegreeProgramId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getDegCampDeptTypeSessDetails/' + qualificationId + '/' + universityId + '/' + universityDegreeProgramId + '/0/0/0/0/' + 'universityCampus')
	}

	public getUniversityDepartments(qualificationId, universityId, universityDegreeProgramId, campusId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getDegCampDeptTypeSessDetails/' + qualificationId + '/' + universityId + '/' + universityDegreeProgramId + '/' + campusId + '/0/0/0/' + 'universityDepartment')
	}

	public getUniversityDegreeType(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getDegCampDeptTypeSessDetails/' + qualificationId + '/' + universityId + '/' + universityDegreeProgramId + '/' + campusId + '/' + departmentId + '/0/0/' + 'degreeType')
	}

	public getUniversitySessions(qualificationId, universityId, universityDegreeProgramId, campusId, departmentId, degreeTypeId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getDegCampDeptTypeSessDetails/' + qualificationId + '/' + universityId + '/' + universityDegreeProgramId + '/' + campusId + '/' + departmentId + '/' + degreeTypeId + '/0/' + 'sessionType')
	}

	public getEducationMajorList(disciplineId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getEducationMajorList/' + disciplineId)
	}

	public getUniversityListByCountryAndSector(countryId, sectorId, categoryId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getUniversityListByCountryAndSector/' + countryId + '/' + sectorId + '/' + categoryId);
	}

	public getOrganizationListByCountryAndSector(countryId, sectorId, categoryId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getOrganizationListByCountryAndSector/' + countryId + '/' + sectorId + '/' + categoryId);
	}

	public saveOrUpdateEmployment(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'profile/saveEmploymentDetails', payload);
	}
}
